// extracted by mini-css-extract-plugin
module.exports = {"svg":"spinner_svg__4Ip3H","rotator":"spinner_rotator__CItAw","circle":"spinner_circle___r2PS","dash":"spinner_dash__RGf6r","colors":"spinner_colors__TTRvJ"};